import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Department, SiteCodes, WorkArea } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-workarea-dialog',
  templateUrl: './add-workarea-dialog.component.html',
  styleUrls: ['./add-workarea-dialog.component.css']
})
export class AddWorkareaDialogComponent implements OnInit {

  constructor(
    public dialogRef:MatDialogRef<AddWorkareaDialogComponent>,
    private _safetyConfigService:SafetyConfigService,
    @Inject(MAT_DIALOG_DATA) public data: any

  ) { }

  selectedName:string="";
  selectedDescription:string="";
  siteCodesList: SiteCodes[]=[];
  inputValuestate:number
  DepartmetnID_:number
  departmentlist:Department[]=[];

  ngOnInit() {
    this. loadSiteList();
    this.DepartmetnID_=this.data.catId
    this. getdepartmentlist();
  }

  state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }
  loadSiteList()
  {
    this._safetyConfigService.getAllSitesList().subscribe(sites =>
    { 
      console.log('sitelist',sites)
      this.siteCodesList=sites;
      
    });
  }
  DialogClose(){
    this.dialogRef.close(false)
  }
  addWorkArea()
  {

    let model= new WorkArea()
    model.WorkAreaName=this.selectedName;
    model.WorkAreaDescription=this.selectedDescription
    model.DepartmentID=this.data.catId
    model.SiteId=this.inputValuestate
    console.log('input values',model)
this._safetyConfigService.CreateWorkArea(model).subscribe(res =>{
 
  if(res.m_Item1=true){
    console.log('result', res)
    this.DialogClose();
   

  }});
  }

  getdepartmentlist(){
    this._safetyConfigService.GetDepartmentsAndWorkAreas().subscribe(res=>{ 
    this.departmentlist=res.Departments;
    this.departmentlist= res.Departments.filter(x=>x.ID==this.DepartmetnID_)    
    this.inputValuestate=this.departmentlist[0].SiteId
    })
  }
}

